import classNames from 'classnames';
import React from 'react';

import { StepIconProps } from '@material-ui/core/StepIcon';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '34px',
    height: '34px',
    borderRadius: '10px',
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.white.main,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '34px',
    textAlign: 'center',
    fontFamily: 'Montserrat',
    boxShadow: '0 10px 24px rgba(31, 41, 55, 0.08)',
  },
  inactive: {
    opacity: 0.65,
  },
}));

const LaunchStepIcon = ({ active, completed, icon }: StepIconProps) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, !active && !completed && classes.inactive)}>
      {icon}
    </div>
  );
};

export default LaunchStepIcon;
